import React, { useState } from "react";
import Logo from "../../assets/images/Yogify.png";
import { GiPrayerBeads } from "react-icons/gi";
import { RiSecurePaymentLine } from "react-icons/ri";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import apiClient from "../../services/apiClient";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import LoginBanner from '../../assets/images/login.jpg'

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validatePassword = (password) => {
    if (password.length < 8) {
      return "Password must be at least 8 characters long";
    }
    
    return "";
  };

  const validateForm = () => {
    let isValid = true;

    const passwordValidation = validatePassword(password);
    if (passwordValidation) {
      setPasswordError(passwordValidation);
      isValid = false;
    } else {
      setPasswordError("");
    }

    if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      isValid = false;
    } else {
      setConfirmPasswordError("");
    }

    if (!password.trim()) {
      setPasswordError("Password is required");
      isValid = false;
    }

    if (!confirmPassword.trim()) {
      setConfirmPasswordError("Confirm password is required");
      isValid = false;
    }

    return isValid;
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (passwordError) setPasswordError("");
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    if (confirmPasswordError) setConfirmPasswordError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    const email = localStorage.getItem("email");
    const otp = localStorage.getItem("otp");

    if (!email || !otp) {
      toast.error("Session expired. Please request a new OTP.");
      navigate("/auth/forgotpassword");
      return;
    }

    setIsLoading(true);

    try {
      const response = await apiClient.post("/reset-password", {
        email: email,
        password: password,
        confirm_password: confirmPassword,
        otp: otp,
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("Password changed successfully!");
        
        // Clear stored data
        localStorage.removeItem("email");
        localStorage.removeItem("otp");
        
        // Redirect to login page
        setTimeout(() => {
          navigate("/auth/login");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      console.error("Error changing password:", error);
      
      if (error.response) {
        const message = error.response.data?.message || "Failed to change password. Please try again.";
        
        if (error.response.status === 400) {
          toast.error("Invalid OTP or OTP expired");
          // navigate("/auth/forgotpassword");
        } else if (error.response.status === 404) {
          toast.error("User not found. Please request a new OTP.");
          // navigate("/auth/forgotpassword");
        } else {
          toast.error(message);
        }
      } else if (error.request) {
        toast.error("Network error. Please check your connection and try again.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div id="ChangePassword">
      <div className="container">
        <div className="LoginMain">
          <div className="LoginBox">
            <div className="LoginLeftBox">
              {/* <div className="LoginLogo">
                <img src={Logo} alt="Yogify Logo" />
              </div>
              <div className="LoginTitle">
                <h2>
                  Authentic Spiritual Essentials to Help You Connect with Your
                  True Self
                </h2>
              </div>
              <div className="ProductSecureBox">
                <div className="SecureBox">
                  <div className="IconBox">
                    <GiPrayerBeads className="SecureIcon" />
                  </div>
                  <div className="SecureTitle">
                    <p>Soulful Accessories</p>
                  </div>
                  <div className="SecureDescription">
                    <p>Crafted with Trusted Spiritual Quality</p>
                  </div>
                </div>

                <div className="SecureBox">
                  <div className="IconBox">
                    <RiSecurePaymentLine className="SecureIcon" />
                  </div>
                  <div className="SecureTitle">
                    <p>Secure Checkout</p>
                  </div>
                  <div className="SecureDescription">
                    <p>Multiple Payment Options — Fast, Safe & Secure</p>
                  </div>
                </div>
              </div> */}
              <img src={LoginBanner} alt="" />
            </div>
            <div className="LoginRightBox">
              <div className="Title">
                <h2>Change your Password</h2>
                <p>
                  Create a new strong password for your account.
                </p>
              </div>

              <div className="LoginFormGroup">
                <form onSubmit={handleSubmit}>
                  <div className="FormField PasswordField">
                    <label>Enter New Password</label>
                    <div className="PasswordInputWrapper">
                      <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={handlePasswordChange}
                        placeholder="Enter your new password"
                        disabled={isLoading}
                        className={passwordError ? "error" : ""}
                      />
                      <button
                        type="button"
                        className="TogglePassword"
                        onClick={togglePasswordVisibility}
                        disabled={isLoading}
                      >
                        {showPassword ? (
                          <AiOutlineEye />
                        ) : (
                          <AiOutlineEyeInvisible />
                        )}
                      </button>
                    </div>
                    {passwordError && <span className="error-message">{passwordError}</span>}
                  </div>
                  
                  <div className="FormField PasswordField">
                    <label>Confirm New Password</label>
                    <div className="PasswordInputWrapper">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        placeholder="Confirm your new password"
                        disabled={isLoading}
                        className={confirmPasswordError ? "error" : ""}
                      />
                      <button
                        type="button"
                        className="TogglePassword"
                        onClick={toggleConfirmPasswordVisibility}
                        disabled={isLoading}
                      >
                        {showConfirmPassword ? (
                          <AiOutlineEye />
                        ) : (
                          <AiOutlineEyeInvisible />
                        )}
                      </button>
                    </div>
                    {confirmPasswordError && <span className="error-message">{confirmPasswordError}</span>}
                  </div>
                  
                  <div className="LoginBtn">
                    <button 
                      type="submit" 
                      disabled={isLoading}
                      className={isLoading ? "loading" : ""}
                    >
                      {isLoading ? "Changing Password..." : "Change Password"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;